import React from 'react';
import {Form, FormGroup, Input, Label, Container, Button} from 'reactstrap';

const AddCourse=()=>{
    return(
        <div>
            <h2 style={{padding:'30px', paddingBottom:'5px'}} >  Fill Course Details</h2>
            <Form style={{textAlign:'left', padding:'30px'}}>
                
                <FormGroup>
                    <Label for='userId'>CourseId</Label> <br/>
                    <Input type="text" placeholder='Enter here' name="userId" id="userId"  />
                </FormGroup>

                <FormGroup>
                    <Label for='title'>Course Title</Label> <br/>
                    <Input type='text' placeholder="Enter Title here" id='title' />
                </FormGroup>

                <FormGroup>
                    <Label for="description">Course Description</Label> <br/>
                    <Input type="textarea" placeholder='Enter Description here' id='description' 
                    style={{height:200}} />
                </FormGroup>
            </Form>
            <Container style={{textAlign:'center', paddingBottom:'30px'}}  >
                <Button color="success">Add Course</Button>
                <Button color="warning ms-3">Clear</Button>
            </Container>
        </div>
    );
}
export default AddCourse;